export default __webpack_public_path__ + "static/media/Create-documentation.6ecba2a7.md";